import { useNavigate } from "react-router-dom";
import ScannerForm from "components/scanner/ScannerForm";
import { createScanner } from "api/scanner.api"; // Import your scanner API function
import Alert from "components/common/Alert";
import { useState, useRef, useEffect } from "react";
// import SuccessModal from "components/SuccessModal";
import Toast from "components/Toast";

export default function CreateScanner() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  // const [showSuccess, setShowSuccess] = useState(false);

  const companyId = localStorage.getItem("company_id");
  const alertRef = useRef(null);
  const [userId, setUserId] = useState(null);
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      setUserId(userData.userId);
    }
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [alert]);

  return (
    <>
      {alert && (
        <div ref={alertRef}>
          <Alert
            type={alert.type}
            message={alert.message}
            onClose={() => setAlert(null)}
          />
        </div>
      )}

      <ScannerForm
        onSubmit={async (formData) => {
          try {
            const payload = {
              ...formData,
              company_id: companyId,
              userId: userId,
            };

            const res = await createScanner(payload);
            if (res.data.success) {
              setToast({
                open: true,
                title: "Created Successfully!",
                message: "Scanner has been created successfully.",
                type: "success",
              });
            }
            // navigate("/admin/scanners");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message || "Failed to create scanner",
            });
          }
        }}
        onBack={() => navigate("/admin/scanners")}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1000}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          // 3. Navigate after toast closes/timer finishes
          navigate("/admin/scanners");
        }}
      />
      {/* <SuccessModal
        open={showSuccess}
        onClose={() => {
          setShowSuccess(false);
          navigate("/admin/scanners");
        }}
        title="Created Successfully!"
        message="Scanner has been create successfully."
        buttonText="OK"
        buttonBg="bg-[#1A1A1A] hover:bg-[#1A1A1A]"
        buttonTextColor="text-white"
      /> */}
    </>
  );
}
